import {NoopScrollStrategy} from "@angular/cdk/overlay";
import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {FormBuilder, FormGroup} from "@angular/forms";
import {MatDialog} from "@angular/material/dialog";
import {AuthManagerService} from "src/app/auth/auth-manager.service";
import {LoginData} from "src/app/auth/auth.model";
import {PasswordRecoveryDialogComponent} from "./password-recovery-dialog/password-recovery-dialog.component";
import {RegisterDialogComponent} from "./register-dialog/register-dialog.component";
import {MessageService} from "../message/message.service";
import { requiredFieldValidator } from "../validation/validators";

@Component({
  selector: 'app-nav-link',
  templateUrl: './nav-link.component.html',
  styleUrls: ['./nav-link.component.scss']
})
export class NavLinkComponent implements OnInit {

  form: FormGroup;
  rememberMe: boolean = false;
  showError: boolean = false;

  @Input() text: string;
  @Input() linkTo: string;
  @Input() isLogin = false;
  @Output() login = new EventEmitter();

  constructor(
    private formBuilder: FormBuilder,
    private auth: AuthManagerService,
    private dialog: MatDialog,
    private message: MessageService
  ) {
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      customerNumber: ['', requiredFieldValidator()],
      username: ['', requiredFieldValidator()],
      password: ['', requiredFieldValidator()]
    });
  }

  submit() {
    event.stopPropagation();

    this.form.get('customerNumber').markAsTouched();
    this.form.get('username').markAsTouched();
    this.form.get('password').markAsTouched();

    if(this.form.valid) {
      let data: LoginData = {
        customerNumber: this.form.get("customerNumber").value,
        username: this.form.get("username").value,
        password: this.form.get("password").value,
        rememberMe: this.rememberMe
      };
      this.auth.login(data).subscribe(response => {
        if (response.success) {
          this.login.emit();
        } else {
          this.showError = true;
        }
      });
    } else {
      this.showError = true;
    }
  }

  register() {
    this.dialog.open(RegisterDialogComponent, {
      width: '300px',
      scrollStrategy: new NoopScrollStrategy()
    });
  }

  passwordRecovery() {
    this.dialog.open(PasswordRecoveryDialogComponent, {
      width: '250px',
      scrollStrategy: new NoopScrollStrategy()
    });
  }
}
